import * as React from "react";
import { Card, Table, Tag, Button } from "antd";
import { NavLink } from "react-router-dom";

export interface User {
  id: string;
  email: string;
  name: string;
  roles: Role[];
  lockedAt: string | null;
}

interface Role {
  name: string;
}

export interface Props {
  users: Array<User | null> | null;
  loading?: boolean;
}

export interface State {}

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (text: string, user: User) => (
      <>
        <NavLink to={`/users/${user.id}`}>{user.name}</NavLink>
      </>
    )
  },
  {
    title: "Mail",
    dataIndex: "email",
    key: "email"
  },
  {
    title: "Roles",
    key: "roles",
    dataIndex: "roles",
    render: (roles: Role[], user: User) => (
      <span>
        {roles.map(role => (
          <Tag color="blue" key={role.name}>
            {role.name}
          </Tag>
        ))}
        {user.lockedAt && <Tag color="red">Locked</Tag>}
      </span>
    )
  }
  /*{
    title: "Action",
    key: "action",
    render: (text: string, user: User) => (
      <span>
        <a href="javascript:;">Invite {user.name}</a>
        <Divider type="vertical" />
        <a href="javascript:;">Delete</a>
      </span>
    )
  }*/
];

export default class UserList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <Card
        title="All Users"
        bodyStyle={{ padding: 0 }}
        style={{ marginTop: 30 }}
        extra={
          <NavLink to="/users/add">
            <Button>Create</Button>
          </NavLink>
        }
      >
        <Table
          rowKey="id"
          loading={this.props.loading}
          columns={columns}
          dataSource={this.props.users || []}
        />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserList/UserList.tsx